
import { all, takeLatest } from 'redux-saga/effects';
import * as userAction from '../actions/userActionsHelper';
import * as userSagasHelper from './userSagasHelper';
import * as questionAction from '../actions/questionActionsHelper';
import * as questionSagasHelper from './questionSagasHelper';
import * as packageAction from '../actions/packageActionsHelper';
import * as packageSagasHelper from './packageSagasHelper';
import * as recordAction from '../actions/recordActionsHelper';
import * as recordSagasHelper from './recordSagasHelper';
import * as receiptAction from '../actions/receiptActionsHelper';
import * as receiptSagasHelper from './receiptSagasHelper';
import * as testReportAction from '../actions/testReportActionsHelper';
import * as testReportSagasHelper from './testReportSagasHelper';
import * as examinationAction from '../actions/examinationActionsHelper';
import * as examinationSagasHelper from './examinationSagasHelper';
import * as announcementAction from '../actions/announcementActionsHelper';
import * as announcementSagasHelper from './announcementSagasHelper';

function* appSaga() {
  console.log("🔥 SAGAS INITIALIZED");

  yield all([
    // User handling sagas
    takeLatest(userAction.loginUser.request, userSagasHelper.handleLogin),
    takeLatest(userAction.logoutUser.request, userSagasHelper.handleLogout),
    takeLatest(userAction.refreshUser.request, userSagasHelper.handleRefreshUser),
    takeLatest(userAction.createUser.request, userSagasHelper.handleCreateUser),
    takeLatest(userAction.getUser.request, userSagasHelper.handleGetUsers),
    takeLatest(userAction.updateUser.request, userSagasHelper.handleUpdateUser),
    takeLatest(userAction.deleteUser.request, userSagasHelper.handleDeleteUser),
    takeLatest(userAction.forgotPassword.request, userSagasHelper.handleForgotPassword),
    takeLatest(userAction.resetPassword.request, userSagasHelper.handleResetPassword),
    takeLatest(userAction.resendConfirmation.request, userSagasHelper.handleResendConfirmation),
    takeLatest(userAction.uploadAvatar.request, userSagasHelper.handleUploadAvatar),

    // Question handling sagas
    takeLatest(questionAction.getQuestionForPractice.request, questionSagasHelper.handleGetQuestionForPractice),

    // Package handling sagas
    takeLatest(packageAction.getPackage.request, packageSagasHelper.handleGetPackages),
    takeLatest(packageAction.getPackageById.request, packageSagasHelper.handleGetPackageById),
    takeLatest(packageAction.createPackage.request, packageSagasHelper.handleCreatePackage),
    takeLatest(packageAction.updatePackage.request, packageSagasHelper.handleUpdatePackage),
    takeLatest(packageAction.deletePackage.request, packageSagasHelper.handleDeletePackage),
    takeLatest(packageAction.getPublicPackage.request, packageSagasHelper.handleGetPublicPackages),

    // Record handling sagas
    takeLatest(recordAction.getRecord.request, recordSagasHelper.handleGetRecords),
    takeLatest(recordAction.updateRecord.request, recordSagasHelper.handleUpdateRecord),
    takeLatest(recordAction.deleteRecord.request, recordSagasHelper.handleDeleteRecord),

    // Session Management Record sagas
    takeLatest(recordAction.checkActiveRecord.request, recordSagasHelper.handleCheckActiveRecord),
    takeLatest(recordAction.createNewRecord.request, recordSagasHelper.handleCreateNewRecord),
    takeLatest(recordAction.pauseRecord.request, recordSagasHelper.handlePauseRecord),
    takeLatest(recordAction.resumeRecord.request, recordSagasHelper.handleResumeRecord),
    takeLatest(recordAction.endRecord.request, recordSagasHelper.handleEndRecord),
    takeLatest(recordAction.updateRecordAndGetNextQuestion.request, recordSagasHelper.handleUpdateRecordAndGetNextQuestion),
    takeLatest(recordAction.createRecordAndGetFirstQuestion.request, recordSagasHelper.handleCreateRecordAndGetFirstQuestion),
    takeLatest(recordAction.resumeRecordAndGetQuestion.request, recordSagasHelper.handleResumeRecordAndGetQuestion),
    takeLatest(recordAction.getUserSectionStats.request, recordSagasHelper.handleGetUserSectionStats),
    takeLatest(recordAction.getMonthlySubjectAccuracy.request, recordSagasHelper.handleGetMonthlySubjectAccuracy),
    takeLatest(recordAction.getDailyAccuracyTrend.request, recordSagasHelper.handleGetDailyAccuracyTrend),

    // Receipt handling sagas
    takeLatest(receiptAction.getReceipt.request, receiptSagasHelper.handleGetReceipts),
    takeLatest(receiptAction.createReceipt.request, receiptSagasHelper.handleCreateReceipt),
    takeLatest(receiptAction.updateReceipt.request, receiptSagasHelper.handleUpdateReceiptPaypal), // Paypal
    takeLatest(receiptAction.updateReceipt.request, receiptSagasHelper.handleUpdateReceiptMomo), // Momo
    takeLatest(receiptAction.deleteReceipt.request, receiptSagasHelper.handleDeleteReceipt),

    // Test Report handling sagas
    takeLatest(testReportAction.getTestReport, testReportSagasHelper.handleGetTestReport),
    takeLatest(testReportAction.createTestReport, testReportSagasHelper.handleCreateTestReport),
    takeLatest(testReportAction.getUserTestReports, testReportSagasHelper.handleGetUserTestReports),
    takeLatest(testReportAction.getLatestTestReport, testReportSagasHelper.handleGetLatestTestReport),

    // Examination handling sagas
    takeLatest(examinationAction.getExamination.request, examinationSagasHelper.handleGetExaminations),
    takeLatest(examinationAction.createExamination.request, examinationSagasHelper.handleCreateExamination),
    takeLatest(examinationAction.getExaminationById.request, examinationSagasHelper.handleGetExaminationById),
    takeLatest(examinationAction.startExamination.request, examinationSagasHelper.handleStartExamination),
    takeLatest(examinationAction.pauseExamination.request, examinationSagasHelper.handlePauseExamination),
    takeLatest(examinationAction.completeExamination.request, examinationSagasHelper.handleCompleteExamination),
    takeLatest(examinationAction.getExaminationQuestions.request, examinationSagasHelper.handleGetExaminationQuestions),
    takeLatest(examinationAction.submitExaminationAnswer.request, examinationSagasHelper.handleSubmitExaminationAnswer),
    takeLatest(examinationAction.getExaminationTimeStatus.request, examinationSagasHelper.handleGetExaminationTimeStatus),
    takeLatest(examinationAction.createExaminationAndNavigate.request, examinationSagasHelper.handleCreateExaminationAndNavigate),
    takeLatest(examinationAction.loadQuestionById.request, examinationSagasHelper.handleLoadQuestionById),

    // Announcement handling sagas
    takeLatest(announcementAction.getActiveAnnouncements.request, announcementSagasHelper.handleGetActiveAnnouncements),
    takeLatest(announcementAction.dismissAnnouncement.request, announcementSagasHelper.handleDismissAnnouncement),
  ]);
}
export default appSaga;